import React, {useMemo} from 'react'
import {useIntl} from 'react-intl'
import {VStack, List, ListItem, Heading} from '@chakra-ui/react'
import Link from '../../../components/link'
import useCustomerServicePageConfig from '../hooks/use-page-config'
import {normalizeSfccLink} from '../../../utils/url'

const CSQuickLinks = () => {
    const {formatMessage, locale} = useIntl()
    const {quicklinks} = useCustomerServicePageConfig()

    const normalizedQuicklinks = useMemo(
        () =>
            quicklinks?.map(({link, label}) => ({
                label,
                href: normalizeSfccLink(locale, link)
            })) ?? [],
        [quicklinks, locale]
    )

    if (!normalizedQuicklinks?.length) {
        return null
    }

    const quickLinksAriaLabel = formatMessage({
        id: 'cs.layout.quicklinks.arialabel',
        defaultMessage: 'Quicklink Navigation'
    })

    return (
        <VStack
            as="nav"
            alignItems="center"
            data-testid="cs-quick-links"
            aria-label={quickLinksAriaLabel}
        >
            <Heading
                as="h2"
                textStyle="Regular 2XLarge"
                pb={{base: 8, md: 10}}
                pt={{base: 12, md: 20}}
            >
                {formatMessage({
                    id: 'cs.layout.quicklinks',
                    defaultMessage: 'Quicklinks'
                })}
            </Heading>
            <List textAlign="center" spacing={3} pb={28} styleType="none">
                {normalizedQuicklinks.map((el) => (
                    <ListItem key={el.label} mt={0}>
                        <Link to={el.href}>{el.label}</Link>
                    </ListItem>
                ))}
            </List>
        </VStack>
    )
}

export default CSQuickLinks
